export let julyUppercase = "goW$B";
export default {julyUppercase};